import PolicyLayout from './PolicyLayout';

export default function TermsPage() {
  return (
    <PolicyLayout
      title="Terms & Conditions"
      subtitle="The rules and agreement that govern your use of DotCall."
    >
      <p>
        These Terms &amp; Conditions ("Terms") constitute a legally binding agreement between you ("User",
        "you") and DotCall ("we", "our", "us") governing your access to and use of the DotCall AI voice
        agent platform, website, and related services ("Services"). By registering for or using the Services,
        you agree to these Terms.
      </p>

      <h2>1. Eligibility</h2>
      <p>You must be at least 18 years old and legally competent to enter into a contract under the Indian
        Contract Act, 1872. If you are using the Services on behalf of an organization, you represent that you
        have authority to bind that organization to these Terms.</p>

      <h2>2. Account &amp; Security</h2>
      <ul>
        <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
        <li>You are responsible for all activities that occur under your account.</li>
        <li>You must notify us immediately of any unauthorized access or security breach.</li>
        <li>We may suspend or terminate accounts involved in fraud, abuse, or violation of these Terms.</li>
      </ul>

      <h2>3. Acceptable Use</h2>
      <p>You agree not to use the Services to:</p>
      <ul>
        <li>Make unsolicited or spam calls, including any call that violates TRAI Telecom Commercial
          Communications Customer Preference Regulations (TCCCPR) or the Do Not Disturb (DND) registry.</li>
        <li>Impersonate any person or entity, or misrepresent your affiliation.</li>
        <li>Engage in illegal, fraudulent, harassing, defamatory, or deceptive activity.</li>
        <li>Upload malware, attempt to reverse engineer the platform, or interfere with its operation.</li>
        <li>Scrape, copy, or redistribute any part of the Services without our written consent.</li>
        <li>Violate any applicable Indian or international law, including data-protection, consumer-protection,
          or telecom regulations.</li>
      </ul>

      <h2>4. Subscription &amp; Billing</h2>
      <ul>
        <li><strong>Free Plan</strong> — 10 minutes lifetime trial with Grok Voice AI; hard stop after limit.</li>
        <li><strong>Standard Plan</strong> — ₹2,999/month, 2 agents, 180 minutes included, ₹8/min call rate.</li>
        <li><strong>Premium Plan</strong> — ₹7,999/month, 5 agents, 650 minutes included, ₹6.5/min call rate.</li>
        <li><strong>Enterprise Plan</strong> — ₹15,999/month, pay-as-you-go with Grok Voice AI at ₹5.5/min from wallet balance.</li>
      </ul>
      <p>All fees are in Indian Rupees (INR) and exclusive of applicable taxes (GST). Subscriptions auto-renew
        each billing cycle unless cancelled before the renewal date. Wallet balances are non-refundable but do
        not expire.</p>

      <h2>5. Telephony &amp; Third-Party Services</h2>
      <p>Voice calls are carried over Vobiz Cloud Telephony and powered by Grok Voice AI. Call quality, latency, and
        availability depend on these providers and on the user's telecom network. You are responsible for
        complying with all laws that apply to calls you originate or receive, including obtaining necessary
        consents and respecting DND/DNC registries.</p>

      <h2>6. Customer Data &amp; Ownership</h2>
      <p>You retain all rights to data you upload (agent scripts, knowledge-base documents, contact lists, call
        recordings). You grant us a limited license to process this data solely to provide the Services. We
        will not sell or use your customer data to train public AI models.</p>

      <h2>7. Intellectual Property</h2>
      <p>The DotCall name, logo, dashboard, source code, and underlying models are owned by or licensed to us
        and protected by Indian and international intellectual property laws. You may not copy, modify, or
        create derivative works except as expressly permitted.</p>

      <h2>8. Service Availability</h2>
      <p>We strive for high uptime but do not guarantee uninterrupted service. Scheduled maintenance will be
        communicated in advance where practical. We are not liable for downtime caused by third-party providers,
        force majeure, or factors beyond our reasonable control.</p>

      <h2>9. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, DotCall's aggregate liability for any claim arising out of or
        relating to the Services shall not exceed the fees paid by you to DotCall in the three (3) months
        preceding the event giving rise to the claim. We are not liable for any indirect, incidental, special,
        consequential, or punitive damages, including loss of profits, data, or goodwill.</p>

      <h2>10. Indemnification</h2>
      <p>You agree to indemnify and hold harmless DotCall, its officers, and employees from any claim, damage,
        or expense (including reasonable legal fees) arising out of your use of the Services, your violation of
        these Terms, or your violation of any law or third-party right — including but not limited to claims
        arising from calls you make via the platform.</p>

      <h2>11. Termination</h2>
      <p>We may suspend or terminate your account for breach of these Terms, non-payment, or misuse of the
        Services. Upon termination, your right to use the Services ceases immediately, and remaining wallet
        balance (if any) shall be forfeited unless expressly agreed otherwise in writing.</p>

      <h2>12. Governing Law &amp; Jurisdiction</h2>
      <p>These Terms are governed by the laws of India. Any dispute arising out of or in connection with these
        Terms shall be subject to the exclusive jurisdiction of the courts at Mumbai, Maharashtra, India.
        Before initiating legal proceedings, parties shall attempt good-faith resolution through negotiation
        for at least 30 days.</p>

      <h2>13. Changes to These Terms</h2>
      <p>We may update these Terms from time to time. Material changes will be notified via email or dashboard.
        Continued use of the Services after the effective date constitutes acceptance of the revised Terms.</p>

      <h2>14. Contact</h2>
      <p>For any questions regarding these Terms, please contact us at
        <strong> support@dotcall.io</strong> or <strong>+91 88798 51335</strong>.</p>
    </PolicyLayout>
  );
}
